[
  {
    "name": "America/Anchorage",
    "gmtOffset": "GMT−9:00",
    "aliases": [
      "Anchorage",
      "Alaska",
      "Juneau",
      "Fairbanks",
      "Nome",
      "Sitka",
      "Ketchikan"
    ]
  },
  {
    "name": "America/Chicago",
    "gmtOffset": "GMT−6:00",
    "aliases": [
      "Chicago",
      "Dallas",
      "Houston",
      "Minneapolis",
      "Kansas City",
      "Winnipeg",
      "Central Time",
      "CST",
      "CDT",
      "Mexico City",
      "Guadalajara",
      "Monterrey",
      "Guatemala City",
      "San Salvador",
      "Tegucigalpa",
      "Managua",
      "San José",
      "Costa Rica",
      "San Antonio",
      "Austin",
      "Memphis",
      "New Orleans",
      "Milwaukee",
      "Oklahoma City",
      "Omaha",
      "Belmopan",
      "Belize City",
      "St. Louis",
      "Nashville",
      "Louisville",
      "Indianapolis",
      "Little Rock",
      "Des Moines",
      "Madison",
      "Lincoln",
      "Wichita",
      "Tulsa"
    ]
  },
  {
    "name": "America/Denver",
    "gmtOffset": "GMT−7:00",
    "aliases": [
      "Denver",
      "Salt Lake City",
      "Boise",
      "Albuquerque",
      "Calgary",
      "Mountain Time",
      "MST",
      "MDT",
      "Phoenix (no DST)",
      "Arizona",
      "Tucson",
      "Mesa",
      "Colorado Springs",
      "El Paso",
      "Edmonton",
      "Santa Fe",
      "Cheyenne",
      "Helena",
      "Bismarck"
    ]
  },
  {
    "name": "America/Halifax",
    "gmtOffset": "GMT−4:00",
    "aliases": [
      "Caracas",
      "Venezuela",
      "Halifax",
      "Atlantic Time",
      "Santo Domingo",
      "Port of Spain",
      "Trinidad",
      "Barbados",
      "La Paz",
      "Bolivia",
      "Guyana",
      "Georgetown",
      "Santiago",
      "Manaus",
      "Bridgetown",
      "Castries",
      "Saint Lucia",
      "Kingstown",
      "Saint Vincent",
      "Roseau",
      "Dominica",
      "Saint George's",
      "Grenada",
      "Basseterre",
      "Saint Kitts",
      "Oranjestad",
      "Aruba",
      "Willemstad",
      "Curaçao",
      "Paramaribo",
      "Suriname",
      "Cayenne",
      "French Guiana",
      "Sucre",
      "Maracaibo",
      "Asunción",
      "Paraguay",
      "Campo Grande"
    ]
  },
  {
    "name": "America/Los_Angeles",
    "gmtOffset": "GMT−8:00",
    "aliases": [
      "Los Angeles",
      "San Francisco",
      "Seattle",
      "Portland",
      "Las Vegas",
      "Vancouver",
      "Pacific Time",
      "PST",
      "PDT",
      "San Diego",
      "Sacramento",
      "Victoria",
      "Tijuana",
      "Ensenada"
    ]
  },
  {
    "name": "America/New_York",
    "gmtOffset": "GMT−5:00",
    "aliases": [
      "Bogotá",
      "Lima",
      "Quito",
      "Panama City",
      "Kingston",
      "Ecuador",
      "Peru",
      "Colombia",
      "New York",
      "Boston",
      "Miami",
      "Atlanta",
      "Philadelphia",
      "Washington DC",
      "Detroit",
      "Toronto",
      "Montreal",
      "Eastern Time",
      "EST",
      "EDT",
      "Charlotte",
      "Raleigh",
      "Orlando",
      "Tampa",
      "Jacksonville",
      "Baltimore",
      "Pittsburgh",
      "Cleveland",
      "Columbus",
      "Cincinnati",
      "Indianapolis",
      "Nashville (ET)",
      "Ottawa",
      "Quebec City",
      "Halifax (ET overlap)",
      "Port-au-Prince",
      "Haiti",
      "Nassau",
      "Bahamas",
      "Havana",
      "Cuba",
      "San Juan",
      "Puerto Rico",
      "Medellín",
      "Cali",
      "Barranquilla",
      "Guayaquil",
      "Callao",
      "Arequipa",
      "Trujillo"
    ]
  },
  {
    "name": "America/Sao_Paulo",
    "gmtOffset": "GMT−3:00",
    "aliases": [
      "Buenos Aires",
      "Montevideo",
      "Argentina",
      "Uruguay",
      "Córdoba",
      "Rosario",
      "ART",
      "São Paulo",
      "Rio de Janeiro",
      "Brasília",
      "Recife",
      "Salvador",
      "Fortaleza",
      "Brazil",
      "BRT",
      "Asunción (summer)",
      "Mendoza",
      "Tucumán",
      "Mar del Plata",
      "Belo Horizonte",
      "Curitiba",
      "Porto Alegre",
      "Belém",
      "Natal",
      "Maceió",
      "São Luís",
      "Teresina",
      "Campo Grande",
      "Goiânia"
    ]
  },
  {
    "name": "America/St_Johns",
    "gmtOffset": "GMT−3:30",
    "aliases": [
      "St. John's",
      "Newfoundland",
      "NST",
      "Corner Brook",
      "Labrador City"
    ]
  },
  {
    "name": "Asia/Bangkok",
    "gmtOffset": "GMT+7:00",
    "aliases": [
      "Bangkok",
      "Ho Chi Minh City",
      "Hanoi",
      "Phnom Penh",
      "Vientiane",
      "Thailand",
      "Vietnam",
      "Cambodia",
      "ICT",
      "Jakarta",
      "Surabaya",
      "Medan",
      "Indonesia",
      "WIB",
      "Chiang Mai",
      "Pattaya",
      "Phuket",
      "Da Nang",
      "Haiphong",
      "Hue",
      "Nha Trang",
      "Siem Reap",
      "Sihanoukville",
      "Bandung",
      "Bekasi",
      "Palembang",
      "Makassar (WIB region)",
      "Kuching (overlap)",
      "Novosibirsk",
      "Tomsk",
      "Krasnoyarsk (winter)",
      "Barnaul"
    ]
  },
  {
    "name": "Asia/Dhaka",
    "gmtOffset": "GMT+6:00",
    "aliases": [
      "Almaty",
      "Astana",
      "Bishkek",
      "Kazakhstan",
      "Kyrgyzstan",
      "ALMT",
      "Dhaka",
      "Chittagong",
      "Bangladesh",
      "BST",
      "Nur-Sultan",
      "Shymkent",
      "Karaganda",
      "Osh",
      "Khulna",
      "Rajshahi",
      "Sylhet"
    ]
  },
  {
    "name": "Asia/Dubai",
    "gmtOffset": "GMT+4:00",
    "aliases": [
      "Baku",
      "Azerbaijan",
      "AZT",
      "Dubai",
      "Abu Dhabi",
      "Muscat",
      "Tbilisi",
      "Yerevan",
      "UAE",
      "GST",
      "Sharjah",
      "Oman",
      "Sohar",
      "Salalah",
      "Rustavi",
      "Ganja",
      "Sumqayit",
      "Réunion",
      "Saint-Denis",
      "Port Louis",
      "Mauritius",
      "Victoria",
      "Seychelles",
      "Moroni",
      "Comoros",
      "Mayotte",
      "Mamoudzou"
    ]
  },
  {
    "name": "Asia/Kabul",
    "gmtOffset": "GMT+4:30",
    "aliases": [
      "Kabul",
      "Afghanistan",
      "AFT",
      "Kandahar",
      "Herat",
      "Mazar-i-Sharif",
      "Jalalabad"
    ]
  },
  {
    "name": "Asia/Karachi",
    "gmtOffset": "GMT+5:00",
    "aliases": [
      "Karachi",
      "Islamabad",
      "Lahore",
      "Pakistan",
      "PST",
      "Tashkent",
      "Ashgabat",
      "Dushanbe",
      "Uzbekistan",
      "UZT",
      "Faisalabad",
      "Rawalpindi",
      "Multan",
      "Gujranwala",
      "Peshawar",
      "Quetta",
      "Samarkand",
      "Namangan",
      "Andijan",
      "Bukhara",
      "Mary",
      "Türkmenabat",
      "Khujand",
      "Maldives",
      "Malé"
    ]
  },
  {
    "name": "Asia/Kathmandu",
    "gmtOffset": "GMT+5:45",
    "aliases": [
      "Kathmandu",
      "Nepal",
      "NPT",
      "Pokhara",
      "Biratnagar",
      "Birgunj",
      "Lalitpur"
    ]
  },
  {
    "name": "Asia/Kolkata",
    "gmtOffset": "GMT+5:30",
    "aliases": [
      "Kolkata",
      "Mumbai",
      "Bombay",
      "Delhi",
      "Bangalore",
      "Chennai",
      "Hyderabad",
      "Ahmedabad",
      "India",
      "IST",
      "New Delhi",
      "Pune",
      "Surat",
      "Jaipur",
      "Lucknow",
      "Kanpur",
      "Nagpur",
      "Patna",
      "Indore",
      "Thane",
      "Bhopal",
      "Visakhapatnam",
      "Kochi",
      "Sri Lanka",
      "Colombo",
      "Sri Jayawardenepura Kotte"
    ]
  },
  {
    "name": "Asia/Shanghai",
    "gmtOffset": "GMT+8:00",
    "aliases": [
      "Shanghai",
      "Beijing",
      "Shenzhen",
      "Guangzhou",
      "Chengdu",
      "Wuhan",
      "Hong Kong",
      "Taipei",
      "Manila",
      "China",
      "CST",
      "HKT",
      "PHT",
      "Singapore",
      "Kuala Lumpur",
      "Malaysia",
      "SGT",
      "MYT",
      "Perth",
      "Western Australia",
      "AWST",
      "Tianjin",
      "Chongqing",
      "Nanjing",
      "Xian",
      "Hangzhou",
      "Shenyang",
      "Harbin",
      "Qingdao",
      "Dalian",
      "Zhengzhou",
      "Jinan",
      "Changsha",
      "Kunming",
      "Ürümqi",
      "Macau",
      "George Town",
      "Penang",
      "Johor Bahru",
      "Ipoh",
      "Cebu",
      "Davao",
      "Quezon City",
      "Caloocan",
      "Bandar Seri Begawan",
      "Brunei",
      "Dili",
      "East Timor",
      "Timor-Leste",
      "Kota Kinabalu",
      "Sandakan",
      "Krasnoyarsk"
    ]
  },
  {
    "name": "Asia/Tehran",
    "gmtOffset": "GMT+3:30",
    "aliases": [
      "Tehran",
      "Iran",
      "IRST",
      "Isfahan",
      "Mashhad",
      "Tabriz",
      "Shiraz",
      "Ahvaz",
      "Karaj"
    ]
  },
  {
    "name": "Asia/Tokyo",
    "gmtOffset": "GMT+9:00",
    "aliases": [
      "Seoul",
      "Busan",
      "Incheon",
      "Korea",
      "KST",
      "Tokyo",
      "Osaka",
      "Sapporo",
      "Fukuoka",
      "Nagoya",
      "Japan",
      "JST",
      "Yokohama",
      "Kawasaki",
      "Kobe",
      "Kyoto",
      "Hiroshima",
      "Sendai",
      "Kitakyushu",
      "Daegu",
      "Daejeon",
      "Gwangju",
      "Ulsan",
      "Suwon",
      "Pyongyang",
      "North Korea",
      "Yakutsk (partial)",
      "Palau",
      "Ngerulmud",
      "Jayapura",
      "Papua (Indonesia)"
    ]
  },
  {
    "name": "Asia/Yangon",
    "gmtOffset": "GMT+6:30",
    "aliases": [
      "Yangon",
      "Mandalay",
      "Myanmar",
      "Burma",
      "MMT",
      "Naypyidaw",
      "Mawlamyine",
      "Bago"
    ]
  },
  {
    "name": "Atlantic/Azores",
    "gmtOffset": "GMT−1:00",
    "aliases": [
      "Azores",
      "Ponta Delgada",
      "Cape Verde",
      "Praia",
      "CVT",
      "Mindelo",
      "Horta"
    ]
  },
  {
    "name": "Atlantic/South_Georgia",
    "gmtOffset": "GMT−2:00",
    "aliases": [
      "South Georgia",
      "Noronha",
      "Fernando de Noronha"
    ]
  },
  {
    "name": "Australia/Adelaide",
    "gmtOffset": "GMT+9:30",
    "aliases": [
      "Adelaide",
      "Darwin",
      "South Australia",
      "Northern Territory",
      "ACST",
      "Alice Springs",
      "Whyalla",
      "Mount Gambier",
      "Palmerston"
    ]
  },
  {
    "name": "Australia/Eucla",
    "gmtOffset": "GMT+8:45",
    "aliases": [
      "Eucla",
      "Australian Central Western",
      "ACWST"
    ]
  },
  {
    "name": "Australia/Lord_Howe",
    "gmtOffset": "GMT+10:30",
    "aliases": [
      "Lord Howe Island",
      "LHST"
    ]
  },
  {
    "name": "Australia/Sydney",
    "gmtOffset": "GMT+10:00",
    "aliases": [
      "Sydney",
      "Melbourne",
      "Brisbane",
      "Canberra",
      "Eastern Australia",
      "AEST",
      "Port Moresby",
      "Papua New Guinea",
      "PGT",
      "Gold Coast",
      "Newcastle",
      "Wollongong",
      "Hobart",
      "Geelong",
      "Townsville",
      "Cairns",
      "Toowoomba",
      "Ballarat",
      "Bendigo",
      "Launceston",
      "Vladivostok",
      "Guam",
      "Hagåtña",
      "Saipan",
      "Northern Mariana Islands",
      "Yakutsk"
    ]
  },
  {
    "name": "Etc/GMT+12",
    "gmtOffset": "GMT−12:00",
    "aliases": [
      "International Date Line West",
      "Baker Island",
      "Howland Island"
    ]
  },
  {
    "name": "Europe/Helsinki",
    "gmtOffset": "GMT+2:00",
    "aliases": [
      "Cairo",
      "Jerusalem",
      "Tel Aviv",
      "Beirut",
      "Amman",
      "Damascus",
      "Khartoum",
      "Tripoli",
      "EET",
      "Johannesburg",
      "Cape Town",
      "Harare",
      "Lusaka",
      "Maputo",
      "Gaborone",
      "Windhoek",
      "Pretoria",
      "SAST",
      "Helsinki",
      "Kyiv",
      "Riga",
      "Tallinn",
      "Vilnius",
      "Bucharest",
      "Sofia",
      "Athens",
      "Nicosia",
      "EEST",
      "Durban",
      "Blantyre",
      "Malawi",
      "Lilongwe",
      "Mbabane",
      "Eswatini",
      "Maseru",
      "Lesotho",
      "Gaza",
      "West Bank",
      "Alexandria",
      "Giza",
      "Port Said",
      "Suez",
      "Benghazi",
      "Misrata",
      "Thessaloniki",
      "Gdańsk",
      "Kaliningrad",
      "Chisinau",
      "Moldova",
      "Minsk (EET period)",
      "Kharkiv",
      "Odessa",
      "Dnipro",
      "Donetsk",
      "Zaporizhzhia",
      "Lviv",
      "Lubumbashi",
      "DRC"
    ]
  },
  {
    "name": "Europe/London",
    "gmtOffset": "GMT+0:00",
    "aliases": [
      "Abidjan",
      "Accra",
      "Dakar",
      "Conakry",
      "Bamako",
      "Freetown",
      "Monrovia",
      "Ouagadougou",
      "London",
      "Dublin",
      "Edinburgh",
      "Lisbon",
      "Reykjavik",
      "Casablanca",
      "GMT",
      "WET",
      "Belfast",
      "Cardiff",
      "Manchester",
      "Birmingham",
      "Glasgow",
      "Liverpool",
      "Bristol",
      "Leeds",
      "Sheffield",
      "Rabat",
      "Marrakech",
      "Fes",
      "Bissau",
      "Guinea-Bissau",
      "Banjul",
      "Gambia",
      "Nouakchott",
      "Mauritania",
      "Yamoussoukro",
      "Côte d'Ivoire",
      "Lomé",
      "Togo",
      "Cotonou",
      "Benin",
      "Porto-Novo",
      "Niamey",
      "Niger",
      "Malabo",
      "Equatorial Guinea",
      "São Tomé",
      "São Tomé and Príncipe"
    ]
  },
  {
    "name": "Europe/Moscow",
    "gmtOffset": "GMT+3:00",
    "aliases": [
      "Nairobi",
      "Addis Ababa",
      "Dar es Salaam",
      "Mogadishu",
      "Kampala",
      "Antananarivo",
      "EAT",
      "Moscow",
      "Saint Petersburg",
      "Minsk",
      "Baghdad",
      "Riyadh",
      "Kuwait City",
      "Doha",
      "Aden",
      "MSK",
      "Ankara",
      "Istanbul",
      "Izmir",
      "Bursa",
      "Antalya",
      "Adana",
      "Konya",
      "Diyarbakır",
      "Sanaa",
      "Yemen",
      "Manama",
      "Bahrain",
      "Asmara",
      "Eritrea",
      "Djibouti",
      "Djibouti City",
      "Jeddah",
      "Mecca",
      "Medina",
      "Kigali",
      "Rwanda",
      "Bujumbura",
      "Burundi",
      "Juba",
      "South Sudan",
      "Mombasa",
      "Kisumu",
      "Dodoma",
      "Zanzibar",
      "Entebbe",
      "Novosibirsk (MSK+4 transition)",
      "Simferopol",
      "Volgograd",
      "Rostov-on-Don",
      "Krasnodar",
      "Sochi"
    ]
  },
  {
    "name": "Europe/Paris",
    "gmtOffset": "GMT+1:00",
    "aliases": [
      "Lagos",
      "Kinshasa",
      "Kano",
      "Ibadan",
      "Algiers",
      "Tunis",
      "Luanda",
      "Douala",
      "WAT",
      "Paris",
      "Berlin",
      "Rome",
      "Madrid",
      "Amsterdam",
      "Brussels",
      "Vienna",
      "Warsaw",
      "Prague",
      "Budapest",
      "Stockholm",
      "Oslo",
      "Copenhagen",
      "Zurich",
      "Geneva",
      "Barcelona",
      "Milan",
      "CET",
      "CEST",
      "Abuja",
      "Accra (WAT overlap)",
      "Brazzaville",
      "Republic of Congo",
      "Bangui",
      "Central African Republic",
      "Libreville",
      "Gabon",
      "Yaoundé",
      "Cameroon",
      "N'Djamena",
      "Chad",
      "Niamey (WAT)",
      "Ndjamena",
      "Bern",
      "Vaduz",
      "Liechtenstein",
      "Luxembourg City",
      "Monaco",
      "Andorra la Vella",
      "San Marino",
      "Vatican City",
      "Ljubljana",
      "Slovenia",
      "Zagreb",
      "Croatia",
      "Sarajevo",
      "Bosnia and Herzegovina",
      "Podgorica",
      "Montenegro",
      "Pristina",
      "Kosovo",
      "Belgrade",
      "Serbia",
      "Skopje",
      "North Macedonia",
      "Tirana",
      "Albania",
      "Valletta",
      "Malta",
      "Bratislava",
      "Slovakia",
      "Hamburg",
      "Munich",
      "Frankfurt",
      "Cologne",
      "Stuttgart",
      "Düsseldorf",
      "Naples",
      "Turin",
      "Palermo",
      "Seville",
      "Valencia",
      "Bilbao",
      "Porto",
      "Kraków",
      "Wrocław",
      "Łódź",
      "Poznań"
    ]
  },
  {
    "name": "Pacific/Auckland",
    "gmtOffset": "GMT+12:00",
    "aliases": [
      "Auckland",
      "Wellington",
      "Christchurch",
      "New Zealand",
      "NZST",
      "Fiji",
      "Suva",
      "Tarawa",
      "Majuro",
      "Marshall Islands",
      "FJT",
      "Hamilton",
      "Tauranga",
      "Dunedin",
      "Palmerston North",
      "Lautoka",
      "Nadi",
      "Funafuti",
      "Tuvalu",
      "Yaren",
      "Nauru",
      "Petropavlovsk-Kamchatsky"
    ]
  },
  {
    "name": "Pacific/Chatham",
    "gmtOffset": "GMT+12:45",
    "aliases": [
      "Chatham Islands",
      "Waitangi",
      "CHAST"
    ]
  },
  {
    "name": "Pacific/Honolulu",
    "gmtOffset": "GMT−10:00",
    "aliases": [
      "Honolulu",
      "Hawaii",
      "Tahiti",
      "Papeete",
      "Rarotonga",
      "Cook Islands",
      "Hilo",
      "Kailua-Kona"
    ]
  },
  {
    "name": "Pacific/Kiritimati",
    "gmtOffset": "GMT+14:00",
    "aliases": [
      "Kiritimati",
      "Christmas Island",
      "Line Islands",
      "Kiribati",
      "LINT"
    ]
  },
  {
    "name": "Pacific/Marquesas",
    "gmtOffset": "GMT−9:30",
    "aliases": [
      "Marquesas Islands",
      "Nuku Hiva",
      "French Polynesia"
    ]
  },
  {
    "name": "Pacific/Noumea",
    "gmtOffset": "GMT+11:00",
    "aliases": [
      "Nouméa",
      "New Caledonia",
      "Honiara",
      "Solomon Islands",
      "NCT",
      "Port Vila",
      "Vanuatu",
      "Palikir",
      "Micronesia",
      "Pohnpei",
      "Magadan",
      "Sakhalin"
    ]
  },
  {
    "name": "Pacific/Pago_Pago",
    "gmtOffset": "GMT−11:00",
    "aliases": [
      "Pago Pago",
      "Apia",
      "Midway",
      "Niue",
      "Samoa",
      "American Samoa"
    ]
  },
  {
    "name": "Pacific/Tongatapu",
    "gmtOffset": "GMT+13:00",
    "aliases": [
      "Tongatapu",
      "Tonga",
      "Nuku'alofa",
      "Apia",
      "TOT",
      "Samoa (DST)",
      "Fakaofo",
      "Tokelau"
    ]
  }
]